import {
    /** FETCH APPLICATION  */
    FETCH_APPLICATIONPATIENTCHATRIGHT_FULFILLED,
    FETCH_APPLICATIONPATIENTCHATRIGHT_REJECTED,
    FETCH_APPLICATIONPATIENTCHATRIGHT_PENDING,
    RESET_APPLICATIONPATIENTCHATRIGHT,
} from "../../actions/application/applicationPatientChatRight";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_APPLICATIONPATIENTCHATRIGHT_PENDING:
            return {
                done: false,
                error: false,
                spinner: false
            };
        case FETCH_APPLICATIONPATIENTCHATRIGHT_FULFILLED:
            return {
                ...state,
                applicationPatientChatRight: action.payload,
                done: true,
                error: false,
                spinner: false
            };
        case FETCH_APPLICATIONPATIENTCHATRIGHT_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_APPLICATIONPATIENTCHATRIGHT:
            return {
                initialState,
                done: false,
                error: false,
            };
        default:
            return state;
    }
};